import React from 'react';
import { Menubar } from 'primereact/menubar';
import { InputText } from 'primereact/inputtext';
import { Avatar } from 'primereact/avatar';  
import { useState } from 'react';
import { Link } from 'react-router';
import { useLocation } from "react-router-dom";
import GlobalSearch from './GlobalSearch';


export default function TemplateDemo() {
    
    const location = useLocation();
    
    const [isNewPin, setIsNewPin] = useState(true);

    const items = [
        {
            label: 'Countries',
            icon: 'pi pi-globe',
            url: '/countries'
        },
        {
            label: 'Players',
            icon: 'pi pi-trophy',
            url: '/players'
        },
        {
            label: 'Insights',
            icon: 'pi pi-chart-bar',
            url: '/insights/playersOfTheDay'
        },
        {
            label: 'F.A.Q.',
            icon: 'pi pi-question-circle',
            url: '/faq'
        },
        {
            label: 'About',
            icon: 'pi pi-info-circle',
            url: '/about'
        }
    ];
    const customizedItems = items.map((item) => ({
        ...item,
        className: (location.pathname === item.url || item?.items?.find(item=>item.url === location.pathname)) ? "p-focus" : ""
    }));

    const start = <div><Link to="/"><img alt="logo" src='../pin2.png' height="40" className="mr-2"></img><span className="website-name">GeoRank.io</span></Link></div>;
    const end = (
        <div className="flex align-items-center gap-2">
            <GlobalSearch />
            <i className="pi pi-search" style={{ fontSize: '1.3rem' }}></i>

            {/* <Avatar image="https://primefaces.org/cdn/primereact/images/avatar/amyelsner.png" shape="circle" /> */}
        </div>
    );

    return (
        <Menubar model={customizedItems} start={start} end={end} />
    )
}